require('./js/fsmenu/jlistmenu_v.css');
require('./js/jquery/jquery_file_upload/uploadfile.css');
require('bootstrap/dist/css/bootstrap.css');
require('bootstrap/dist/css/bootstrap-theme.css');
require('font-awesome/css/font-awesome.css');



/*****************
 ** WEBPACK FOOTER
 ** ./jaguar/css.js
 ** module id = 135
 ** module chunks = 1
 **/